import { PaymentSource } from '../server/mpsklad_core/Entity/Enums/PaymentSource'

export const paymentSourceNames: {
  readonly [K in PaymentSource]: string
} = {
  [PaymentSource.None]: 'Нет',
  [PaymentSource.Invoice]: 'Счёт',
  [PaymentSource.MoySklad]: 'МойСклад'
}